import { authApi } from '@/api/authApi';
import { facilitiesApi } from '@/api/facilitiesApi';
import { portfolioApi } from '@/api/portfolioApi';
import { reportingApi } from '@/api/reportingApi';
import { schedulerApi } from '@/api/schedulerApi';
import { syncDataApi } from '@/api/syncDataApi';
import { versionApi } from '@/api/versionApi';
import authReducer from '@/features/auth/authSlice';
import { configureStore } from '@reduxjs/toolkit';

export const makeStore = (preloadedState) =>
  configureStore({
    preloadedState,
    reducer: {
      [authApi.reducerPath]: authApi.reducer,
      [facilitiesApi.reducerPath]: facilitiesApi.reducer,
      [portfolioApi.reducerPath]: portfolioApi.reducer,
      [reportingApi.reducerPath]: reportingApi.reducer,
      [schedulerApi.reducerPath]: schedulerApi.reducer,
      [syncDataApi.reducerPath]: syncDataApi.reducer,
      [versionApi.reducerPath]: versionApi.reducer,
      auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        authApi.middleware,
        facilitiesApi.middleware,
        portfolioApi.middleware,
        reportingApi.middleware,
        schedulerApi.middleware,
        syncDataApi.middleware,
        versionApi.middleware
      ),
  });

export const store = makeStore();

export default store;
